import { styled } from "@monolith-forensics/monolith-ui";

// The Case Files and Photos tab modal alerts (ENG-2133): right under the
// title in every modal (ENG-2309). A lone Learn more sits inline at the end
// of the copy; with the item link too, both go on a line of their own that
// reads as a sentence. The Alert lays its content out as a row, so the body
// wraps everything in one block, or the links become a column on the right.
export const StyledModalAlert = styled.div`
  margin-top: 20px;
  width: 350px;

  // The Alert's icon box is sized for a title. With none, shrink it to the
  // body's line height so the icon centers on the first line of copy.
  & > div > :first-child {
    height: 20px;
  }

  .modal-alert-body {
    flex: 1;
    min-width: 0;
    line-height: 20px;
  }
  .modal-alert-links {
    margin-top: 4px;
  }
  a {
    white-space: nowrap;
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;
